import { render, staticRenderFns } from "./FormDialog.vue?vue&type=template&id=4c1cbd0c&scoped=true"
import script from "./FormDialog.vue?vue&type=script&lang=ts"
export * from "./FormDialog.vue?vue&type=script&lang=ts"
import style0 from "./FormDialog.vue?vue&type=style&index=0&id=4c1cbd0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cbd0c",
  null
  
)

export default component.exports